import axios from 'axios';
import { ADMIN_API_BASE, adminAuthConfig } from './api_admin';

const _err = (e) => { if (e.response) console.error('Admin antifraud error:', e.response.status, e.response.data); };
const multipartAuth = (token) => ({ headers: { Authorization: `Bearer ${token}` } });
const qs = (p) => {
    const s = new URLSearchParams();
    Object.entries(p || {}).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== '') s.append(k, v); });
    return s.toString();
};

export const antifraudError = (e, fb = 'Не удалось выполнить операцию') => e?.response?.data?.error || fb;

export const APIAdminIdentitySearch = async (token, params = {}) => {
    try { const r = await axios.get(`${ADMIN_API_BASE}/identity-search/?${qs(params)}`, adminAuthConfig(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};
export const APIAdminPhotoSearch = async (token, formData) => {
    try { const r = await axios.post(`${ADMIN_API_BASE}/photo-search/`, formData, multipartAuth(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};
export const APIAdminProfilePhotoDuplicates = async (token, profileId, maxDistance) => {
    try {
        const q = maxDistance != null ? `?max_distance=${maxDistance}` : '';
        const r = await axios.get(`${ADMIN_API_BASE}/profiles/${profileId}/photo-duplicates/${q}`, adminAuthConfig(token));
        return r.data;
    } catch (e) { _err(e); throw e; }
};
export const APIAdminFaceCheck = async (token, verificationId) => {
    try { const r = await axios.post(`${ADMIN_API_BASE}/verifications/${verificationId}/face-check/`, {}, adminAuthConfig(token)); return r.data; }
    catch (e) { _err(e); throw e; }
};